import React from "react";
import { useForm } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Forms } from "@/types/form";
import { zodResolver } from "@hookform/resolvers/zod";
import schemas from "@/utils/schemas";
import { useLogin } from "./hooks";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";

const Login: React.FC = () => {
  const form = useForm<Forms["Login"]>({
    defaultValues: { email: "", password: "" },
    resolver: zodResolver(schemas.login),
  });

  const { control, handleSubmit } = form;

  const { onLogin } = useLogin();

  return (
    <Form {...form}>
      <form
        id="login-form"
        onSubmit={handleSubmit(onLogin)}
        className="flex flex-col gap-4 mb-6"
      >
        <FormField
          name="email"
          control={control}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  type="email"
                  placeholder="Email"
                  className="w-full px-3 py-2 border rounded"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          name="password"
          control={control}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  type="password"
                  placeholder="Password"
                  className="w-full px-3 py-2 border rounded"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};

export default Login;
